export function parseSemverParts(version) {
  const parts = String(version || '')
    .trim()
    .split('.')
    .map((segment) => {
      let n = 0;
      for (const ch of segment) {
        if (ch < '0' || ch > '9') break;
        n = n * 10 + (ch.charCodeAt(0) - 48);
      }
      return n;
    });
  return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
}

export function compareSemverDesc(a, b) {
  const ap = parseSemverParts(a);
  const bp = parseSemverParts(b);
  for (let i = 0; i < 3; i += 1) {
    if (ap[i] > bp[i]) return -1;
    if (ap[i] < bp[i]) return 1;
  }
  return 0;
}

export function sortReleasesByVersionDesc(releases) {
  return [...(releases || [])].sort((left, right) =>
    compareSemverDesc(left.version, right.version)
  );
}
